import type { AccusedRecord } from './criminalCaseRequest';

export type AttorneyGeneralDocumentRow = {
  id: string;
  checklistItemId: string;
  documentTypeId: string;
  documentName: string;
  mandatory: boolean;
  fileName: string;
  originalFileName: string;
  fileSize?: number;
  uploadTime: string;
  skipReason: string;
};

export type AttorneyGeneralInlineUpload = {
  id: string;
  fileName: string;
  originalFileName: string;
  fileSize?: number;
  uploadTime: string;
};

export type AttorneyGeneralWizardDraft = {
  fileCategory: string;
  fileCategoryId: string;
  subFileCategoryId: string;
  subFileCategoryName: string;
  applicableAreas: string[];
  applicableAreaIds: string[];

  description: string;
  provinceId: string;
  provinceName: string;
  districtId: string;
  districtName: string;
  caseSource: string;
  highCourtId: string;
  highCourtName: string;
  magistrateCourtId: string;
  magistrateCourtName: string;
  policeStationId: string;
  policeStationName: string;
  countryInvolvedId: string;
  countryInvolvedName: string;
  directionOfRequest: string;
  yourReferenceNumber: string;
  otherExternalReferences: string;
  hasPreviousAdvice: '' | 'yes' | 'no';
  previousAdviceUploads: AttorneyGeneralInlineUpload[];
  hasConnectedAdviceCase: '' | 'yes' | 'no';
  connectedAdviceDetails: string;
  hasActionInstituted: '' | 'yes' | 'no';
  courtTypeId: string;
  courtTypeName: string;
  courtTypeOther: string;
  courtId: string;
  courtName: string;
  isAppealMatter: '' | 'yes' | 'no';
  originalCourt: string;
  judgementOrderUploads: AttorneyGeneralInlineUpload[];
  caseNumber: string;
  hasConnectedMatters: '' | 'yes' | 'no';
  connectedCaseNumber: string;
  connectedAgdFileRef: string;

  plaintiffName: string;
  defendantName: string;
  partyBodyType: '' | 'government' | 'incorporated';
  otherInvolvedInstitutions: string;
  legalOfficerName: string;
  legalOfficerContact: string;

  subjectOfDispute: string;
  incidentDateFrom: string;
  incidentDateTo: string;
  nextStepOfCaseId: string;
  nextStepOfCaseName: string;
  nextStepOfCaseOther: string;
  nextCaseDate: string;

  victimName: string;
  victimDob: string;
  victimGenderId: string;
  victimGenderName: string;

  offenceDateFrom: string;
  offenceDateTo: string;
  placeOfOffence: string;
  accused: AccusedRecord[];

  accusedName: string;
  nationalityId: string;
  nationalityName: string;
  countryOfOriginId: string;
  countryOfOriginName: string;
  accusedDob: string;
  accusedGenderId: string;
  accusedGenderName: string;
  passportOrIdNumber: string;
  custodyStatusId: string;
  custodyStatusName: string;
  custodialAuthority: string;
  lastKnownLocation: string;

  arrestWarrantAvailable: '' | 'yes' | 'no';
  warrantReference: string;
  applicableTreatyArrangement: string;

  petitionerName: string;
  petitionerNic: string;
  petitionerAddress: string;
  petitionerContact: string;
  petitionerEmail: string;
  representedByAttorney: '' | 'yes' | 'no';
  attorneyName: string;
  attorneyContact: string;
  respondentNames: string;
  respondentType: string;
  respondentTypeName: string;
  respondentAddress: string;
  numberOfRespondents: string;

  rtiRequestorName: string;
  rtiNicOrPassport: string;
  rtiAddress: string;
  rtiContactNumber: string;
  rtiEmailAddress: string;
  rtiIsSriLankanCitizen: '' | 'yes' | 'no';
  rtiSpecificPublicAuthorityName: string;
  rtiRequestedInformationDetails: string;
  rtiInformationRequestedTimePeriod: string;
  rtiPreferredMethodOfAccessIds: string[];
  rtiPreferredMethodOfAccessNames: string[];
  rtiPreferredLanguageId: string;
  rtiPreferredLanguageName: string;
  rtiInvolvesLifeOrPersonalLiberty: '' | 'yes' | 'no';
  rtiJustification: string;
  rtiAdditionalNotes: string;

  urgencyLevelId: string;
  urgencyLevelName: string;
  deadline: string;
  urgencyJustification: string;

  deliveryMethodIds: string[];
  deliveryMethods: string[];
  deliveryOther: string;

  documents: AttorneyGeneralDocumentRow[];
  confirmCorrect: boolean;

  draftRequestId: string;
  referenceNo: string;
};

export function newAttorneyGeneralAccused(): AccusedRecord {
  return { id: crypto.randomUUID(), name: '', status: '', statusOther: '' };
}
